/**
 * @param {string} string - The string to clean.
 * @returns {string}      - The cleaned string.
 * @example
 * cleanEscapedQuotes('Hello \\"World\\"') => 'Hello "World"'
 */
export const cleanEscapedQuotes = (string) => string.replace(/\\"/g, '"');
